import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import EditedBySimpleText, {
    EditedBySimpleTextData,
    EditedBySimpleTextDataKeys,
    EditedBySimpleTextDisplayOptions,
} from '../../../../components/edited-by-simple-text/EditedBySimpleText';

const EditedBySimpleTextColumnTemplate = (props: CellTemplateProps) => {
    const data = gridCellData(props);
    return (
        <React.Fragment>
            <GridColumnInspectorHelper cellProps={props}>
                {(inspectorId, disableInspectorForm) => (
                    <EditedBySimpleText
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={data}
                        defaultProps={EditedBySimpleTextColumnTemplateDefaultProps}
                    />
                )}
            </GridColumnInspectorHelper>
        </React.Fragment>
    );
};

export const EditedBySimpleTextColumnTemplateDefaultProps = {} as EditedBySimpleTextDisplayOptions;

export const EditedBySimpleTextColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type EditedBySimpleTextColumnTemplateData = EditedBySimpleTextData & {};

export const EditedBySimpleTextColumnTemplateDataKeys = [...EditedBySimpleTextDataKeys];

export default EditedBySimpleTextColumnTemplate;
